import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import md5 from 'md5';
// 引入performance.now的polyfill
import '../modules/utilPc/performance.now.polyfill';
import loadScript from '../modules/base/loadScript';
import { VideoContentProvider } from '../store/videoContentProvider';
import { VideoContext } from '../store/videoContext';
import Core from '../modules/core';
import Stat from '../modules/vStat/';
import Advideo from '../modules/advideo/';
import AdBehind from '../modules/adBehind/';
import Poster from '../modules/poster/';
import Loading from '../modules/loading/';
import Error from '../modules/error/';
import Recommend from '../modules/recommend/';
import ShareActionBox from '../modules/shareBottom/';
import SignalList from '../modules/signalList/';
import PlayerEvent from '../modules/playerEvent';
import styles from './pcVideo.css';

class PCVideo extends PureComponent {
    static propTypes = {
        videoConfig: PropTypes.any.isRequired,
        playermsg: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        // 页面多组件自动播放逻辑
        if (typeof window.videoOrderList === 'undefined') {
            window.videoOrderList = [1];
        } else {
            window.videoOrderList.push(window.videoOrderList[window.videoOrderList.length - 1] + 1);
        }

        this.videoOrder = window.videoOrderList[window.videoOrderList.length - 1];

        this.state = {
            preLoadReady: false,
            // 是否开始初始化播放器
            adEnded: false,
            // 控制组件销毁与创建
            isRender: true,
            // 视频是否结束
            isEnd: false,
            // 静音标志是否展示
            mutedIconShow: false,
            // 当前播放source index
            currentSource: 0,
            // 广告脚本是否加载
            adScriptLoad: false,
            // 是否展示后贴片广告
            showAdBehind: false,
        };

        /**
         * 是否为用户点击
         */
        this.clickPlay = false;

        /**
         * 是否有广告
         */
        this.adTag = false;

        /**
         * 是否发送过错误统计
         */
        this.sendError = false;

        this.errorShow = false;

        /**
         * 统计模块
         */
        this.vStat = new Stat(props.videoConfig);
    }

    initPlayerStyle = (videoJsOptions) => {
        const { width, height } = videoJsOptions;

        return {
            width,
            height,
            background: '#000000',
            position: 'relative',
            overflow: 'hidden',
        };
    };

    /**
     * 初始化AD参数
     * @returns {object} 参数
     */
    initAdParams(playermsg, state = 'head') {
        const adType = playermsg.adType || '5';
        const frmid = playermsg.frmid || 'free';
        const currentState = state;
        const subject = playermsg.subject || '';
        const ADOrderFirst = playermsg.ADOrderFirst || 0;
        const type = state;

        return {
            frmid,
            adType,
            currentState,
            subject,
            ADOrderFirst,
            type,
        };
    }

    begin = async () => {
        window.hex_md5 = md5;

        try {
            await loadScript('https://x0.ifengimg.com/feprod/c/web/d/ap.js', {
                cache: true,
                timeout: 10000,
            });

            this.setState(
                {
                    preLoadReady: true,
                    adScriptLoad: true,
                },
                () => {
                    setTimeout(() => {
                        this.initEvent();
                    }, 0);
                },
            );
        } catch (error) {
            this.setState(
                {
                    preLoadReady: true,
                    adScriptLoad: false,
                },
                () => {
                    setTimeout(() => {
                        this.initEvent();
                    }, 0);
                },
            );
        }
    };

    initEvent() {
        if (this.advideo) {
            if (this.clickPlay) {
                // 如果是用户点击播放，取消广告静音
                this.advideo.cancleAdCoreMuted();
            }
            /**
             * 广告开始
             */
            this.advideo.on('start', () => {
                if (this.advideo.can === 'no') {
                    this.adTag = true;
                    this.loading.hide();
                    this.initPlayer();
                }
            });

            this.advideo.on('canplay', () => {
                this.loading.hide();
            });

            // this.advideo.on('adbuff', () => {
            //     console.log('广告快结束了');
            // });

            this.advideo.on('ended', (obj) => {
                this.adTag = true;
                /**
                 * 广告结束统计
                 */
                this.vStat.sendVplayer('701020');

                // 如果前贴片播完发现正片播放失败，先不考虑播后贴片，还是原有展示推荐的逻辑
                if (this.errorShow) {
                    this.error.show();
                    this.recommend.show();
                    this.advideo.destory();
                    this.advideo.hide();

                    return;
                }

                if (typeof obj !== 'undefined') {
                    /**
                     * 只播广告 播完啥也不干
                     */
                    if (obj.code === 2) {
                        return false;
                    }
                }
                /**
                 * 该隐藏的地方隐藏、广告销毁
                 */
                if (obj !== 5) {
                    this.advideo.destory();
                    this.advideo.hide();
                }

                /**
                 * 初始化正片
                 */
                this.initPlayer();
            });
        } else {
            this.initPlayer();
        }
    }

    // 初始化正片播放器
    initPlayer = () => {
        this.setState(
            {
                adEnded: true,
            },
            () => {
                this.handlePlayerEvents();
            },
        );
    };

    handleCoreEnd = () => {
        const {
            playermsg: { nextVideoInfo, loop = false },
        } = this.props;

        if (nextVideoInfo && nextVideoInfo.nextLink && !loop) {
            window.location.href = nextVideoInfo.nextLink;
        } else {
            this.setState({
                isEnd: true,
            });
            this.error.show();
            this.recommend.show();
        }

        this.playerEvent.trigger('ended');
    };

    handlePlayerEvents = () => {
        if (this.core) {
            const { playermsg: { autoPlay, playerEventTrigger } = {} } = this.props;

            this.videoStatus = '';

            this.playerEvent = new PlayerEvent(this.core);
            if (playerEventTrigger && typeof playerEventTrigger === 'function') {
                playerEventTrigger(this.playerEvent);
            }

            /**
             * 正片第一次播放
             */
            this.core.on('firstPlay', () => {
                if (this.advideo) {
                    this.advideo.bannerAdShow();
                    this.advideo.cornerAdShow();
                }
            });

            this.core.on('replay', () => {
                this.loading.show();
            });

            this.core.on('canplay', () => {
                this.loading.hide();
                this.error.hide();
                this.recommend.hide();

                this.setState({ showAdBehind: false });

                // 自动播放并且是第一个视频
                if (autoPlay && this.videoOrder === 1) {
                    this.core.play();
                }
            });

            this.core.on('error', (errorCode, currentTime) => {
                /**
                 * 广告播放或者没有广告才可以显示错误
                 */
                if (this.adTag) {
                    this.recommend.show();
                    this.error.show();
                    this.core.destory();
                }

                /**
                 * 没有发过errorcode发送统计代码
                 */
                if (!this.sendError) {
                    this.vStat.sendVplayer(`44000${errorCode}`);
                    if (!currentTime) {
                        this.vStat.sendVplayer('301040');
                    }
                    this.sendError = true;
                    this.errorShow = true;
                }
            });

            // this.core.on('play', () => {
            //     console.log(111);
            //     if (this.advideo && this.advideo.AdPause) {
            //         this.advideo.AdPause.hide();
            //     }
            // });

            this.core.on('seeking', () => {
                this.videoStatus = 'seeking';
            });

            // 隐藏暂停广告逻辑移至timeupdate事件中
            this.core.on('timeupdate', () => {
                this.videoStatus = 'timeupdate';

                if (this.advideo && this.advideo.AdPause) {
                    this.advideo.AdPause.hide();
                }
            });

            this.core.on('pause', () => {
                const prevVideoStatus = this.videoStatus;

                if (this.pauseTimer) {
                    clearTimeout(this.pauseTimer);
                }

                this.pauseTimer = setTimeout(() => {
                    if (
                        this.advideo &&
                        this.core &&
                        this.core.player &&
                        this.core.player.duration() - this.core.player.currentTime() > 0.3 &&
                        prevVideoStatus === 'timeupdate' &&
                        this.videoStatus === 'pause'
                    ) {
                        this.advideo.pauseAdShow();
                    }
                }, 300);

                this.videoStatus = 'pause';
            });

            this.core.on('ended', () => {
                // 隐藏暂停广告
                this.videoStatus = 'ended';
                if (this.advideo && this.advideo.AdPause) {
                    this.advideo.AdPause.hide();
                }

                if (this.props.playermsg.showAdBehind) {
                    this.setState({ showAdBehind: true });
                } else {
                    this.handleCoreEnd();
                }
            });

            this.core.on('volumechange', (currentVolume) => {
                this.setState({
                    mutedIconShow: currentVolume === 0,
                });
            });
        }
    };

    replayVideo = () => {
        this.error.hide();
        this.recommend.hide();
        this.setState({
            isEnd: false,
            showAdBehind: false,
        });
        this.core.setCurrentTime(0);
        this.core.play();
    };

    handleMutedIconClick = () => {
        if (this.core) {
            this.core.changeVolume(0.5);
        }
    };

    destory = () => {
        this.setState({
            isRender: false,
        });
    };

    initPlayerHooks = (providerContext) => {
        const {
            dispatch,
            videoJsOptions: { sources },
            currentPlayIndex,
        } = providerContext;
        const hooks = {};

        hooks['changePlayIndex'] = (index) => {
            if (typeof index === 'number' && index < sources.length) {
                if (currentPlayIndex !== index) {
                    this.changeCurrentSrc(index, sources[index] || {}, dispatch);
                }
            } else {
                console.error('参数错误');
            }
        };

        return hooks;
    };

    componentDidMount() {
        const {
            playermsg: { autoPlay },
        } = this.props;
        // 自动播放
        if (autoPlay) {
            this.begin();
        }

        // 非自动播放
        if (this.poster) {
            this.poster.on('clickInit', () => {
                this.clickPlay = true;
                this.begin();
            });
        }
    }

    componentWillUnmount() {
        // 销毁所有组件实例
        if (this.core) {
            this.core.destory();
        }
        if (this.advideo) {
            this.advideo.destory();
        }
        if (this.loading) {
            this.loading.destroy();
        }
        if (this.error) {
            this.error.destroy();
        }
        if (this.recommend) {
            this.recommend.destroy();
        }
        if (this.poster) {
            this.poster.destroy();
        }
        this.destory();
    }

    changeCurrentSrc = (srcIndex, sourceItem, dispatch) => {
        dispatch({
            type: 'changeSource',
            payload: {
                currentPlaySource: sourceItem,
                currentPlayIndex: srcIndex,
            },
            callback: () => {
                if (this.core) {
                    this.core.changeSource(sourceItem);
                }

                const {
                    playermsg: { changeSourceCb },
                } = this.props;

                if (changeSourceCb) {
                    changeSourceCb(srcIndex, sourceItem);
                }
            },
        });
    };

    handleAdBehind = (type, payload) => {
        if (type === 'ended') {
            this.setState({ showAdBehind: false }, () => {
                this.handleCoreEnd();
            });
        }
    };

    renderVideoChilren = (context) => {
        const { preLoadReady, adEnded, isEnd, mutedIconShow, adScriptLoad, showAdBehind } = this.state;
        const {
            playermsg,
            playermsg: { playerHooks },
        } = this.props;
        const {
            dispatch,
            videoJsOptions,
            videoJsOptions: { sources, showSourcesList },
            currentPlayIndex,
            currentPlaySource,
            narrowWindowMode,
            needBigMutedIcon,
        } = context;

        if (playerHooks) {
            playerHooks(this.initPlayerHooks(context));
        }

        return preLoadReady ? (
            <Fragment>
                {adEnded ? (
                    <Fragment>
                        <Core
                            videoInfo={currentPlaySource}
                            videoJsOptions={videoJsOptions}
                            currentPlayIndex={currentPlayIndex}
                            videoConfig={currentPlaySource}
                            narrowWindowMode={narrowWindowMode}
                            ref={(core) => (this.core = core)}
                        />
                        {showSourcesList ? (
                            <SignalList
                                sources={sources}
                                currentSource={currentPlayIndex}
                                changeCurrentSrc={(index, sourceItem) =>
                                    this.changeCurrentSrc(index, sourceItem, dispatch)
                                }
                            />
                        ) : null}
                        <div
                            style={{ display: mutedIconShow && needBigMutedIcon ? 'block' : 'none' }}
                            className={styles.mutedIcon}
                            onClick={this.handleMutedIconClick}
                        />
                    </Fragment>
                ) : null}
                {adScriptLoad ? (
                    <>
                        <Advideo
                            ref={(advideo) => (this.advideo = advideo)}
                            key="advideo"
                            opt={this.initAdParams(playermsg)}
                            videoinfo={currentPlaySource}
                            playermsg={playermsg}
                        />
                        {showAdBehind ? (
                            <AdBehind
                                option={this.initAdParams(playermsg, 'end')}
                                videoinfo={currentPlaySource}
                                playermsg={playermsg}
                                trigger={this.handleAdBehind}
                            />
                        ) : null}
                    </>
                ) : null}
                <Loading
                    ref={(load) => (this.loading = load)}
                    key="loading"
                    playermsg={playermsg}
                    narrowWindowMode={narrowWindowMode}
                />
                <Error
                    ref={(error) => (this.error = error)}
                    key="error"
                    isEndShow={isEnd}
                    replayAction={this.replayVideo}
                />
                <Recommend
                    ref={(recommend) => (this.recommend = recommend)}
                    key="recommend"
                    videoInfo={currentPlaySource}
                />
            </Fragment>
        ) : (
            <Poster
                ref={(poster) => (this.poster = poster)}
                videoInfo={currentPlaySource}
                dispatch={dispatch}
                narrowWindowMode={narrowWindowMode}
                videoJsOptions={videoJsOptions}
            />
        );
    };

    render() {
        const { playermsg } = this.props;

        return this.state.isRender ? (
            <VideoContentProvider initData={this.props}>
                <VideoContext.Consumer>
                    {(context) => {
                        const {
                            currentPlaySource,
                            videoJsOptions,
                            videoJsOptions: { shareItems, allowResize },
                            narrowWindowMode,
                        } = context;

                        return (
                            <Fragment>
                                <div
                                    // id="playerDiv"
                                    style={this.initPlayerStyle(videoJsOptions)}
                                    className={allowResize && narrowWindowMode ? styles.narrowWindow : ''}>
                                    {this.renderVideoChilren(context)}
                                </div>
                                {shareItems ? (
                                    <ShareActionBox
                                        currentPlaySource={currentPlaySource}
                                        config={videoJsOptions}
                                        narrowWindow={allowResize && narrowWindowMode}
                                        playermsg={playermsg}
                                    />
                                ) : null}
                            </Fragment>
                        );
                    }}
                </VideoContext.Consumer>
            </VideoContentProvider>
        ) : null;
    }
}

export default PCVideo;
